import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Dialog, Loading, Radio, Viewer } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';

const ImageSelectDialog = (props) => {
  const [selected, setSelected] = useState(props.value);

  // 图片预览
  const [showImage, setShowImage] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const setSize = (width, height) => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const result = {
      width,
      height,
    };

    if (windowWidth < width + 100 || windowHeight < height + 100) {
      if (height / width < windowHeight / windowWidth) {
        result.width = windowWidth - 100;
        result.height = ((windowWidth - 100) / width) * height;
      } else {
        result.height = windowHeight - 100;
        result.width = ((windowHeight - 100) / height) * width;
      }
    }
    return result;
  };

  const [loading, setLoading] = useState(true);

  // 图片列表
  const [imageList, setImageList] = useState();
  useEffect(() => {
    setLoading(true);
    RPCFactory.wechatMaterial
      .list(props.wxAppId, { type: 'image' })
      .done((data) => {
        setImageList(data.entities);
        setLoading(false);
      })
      .fail((code, msg) => {
        setLoading(false);
        alert(msg);
      });
  }, [props.wxAppId]);
  const imageliList = [];
  if (_.isArray(imageList)) {
    imageList.forEach((e) => {
      imageliList.push(
        <li className="library-item">
          <div className="cover-box">
            <div className="cover">
              <img
                src={e.url}
                title={e.name}
                alt=""
                onClick={() => {
                  setImageUrl(e.url);
                  setShowImage(true);
                }}
              />
            </div>
            <div className="select-bar">
              <Radio
                checked={selected === e.mediaId}
                value={e.mediaId}
                onChange={() => {
                  setSelected(e.mediaId);
                }}
              ></Radio>
            </div>
          </div>
          <div className="info-box">
            <p className="info-size">
              <span className="name ellipsis" title={e.name}>
                {e.name}
              </span>
            </p>
          </div>
        </li>,
      );
    });
  }

  const handleSubmit = () => {
    if (selected === '') {
      alert('请选择图片');
      return;
    }
    const index = imageList.findIndex((ele) => ele.mediaId === selected);
    props.onSubmit(index >= 0 ? imageList[index] : {});
    props.setShow(false);
  };
  const handleClose = () => {
    props.setShow(false);
  };

  const rolewidth = {
    width: '1200px',
  };
  return (
    <div>
      <Dialog
        backdrop
        type="normal"
        show={props.show}
        onClose={handleClose}
        onSubmit={handleSubmit}
        onCancel={handleClose}
        title={`历史图片${imageList ? `(${imageList.length})` : ''}`}
        style={rolewidth}
      >
        <div className="imgallery">
          {loading ? <Loading show={loading} type="svg" /> : <ul className="library-item-inner clearfix">{imageliList}</ul>}
        </div>
      </Dialog>
      <Viewer
        setSize={setSize}
        show={showImage}
        url={imageUrl}
        type="image"
        onClose={() => {
          setShowImage(false);
        }}
      />
    </div>
  );
};
export default ImageSelectDialog;
